<template>
    <div>
        <d-service-partner
            v-if        = "company"
            v-model     = "edit"
            :company-id = "company.id"
            @stored     = "onStored"
        />
        <v-card flat @click="onCompany" :ripple="false" >
            <div
                class="company lm-border pa-3 pt-2"
                :class="background"
                style="position:relative;"
            >
                <div class="header">
                    <div class="v-flex" style="margin-top: -3px">
                        <div class="name primary--text" >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">{{ company.id }} - {{ company.name }}</span>
                                </template>
                                <span>{{ company.name }}</span>
                            </v-tooltip>
                        </div>
                        <v-spacer />
                        <div>
                            <company-roles
                                :item="company"
                            />
                        </div>

                    </div>
                </div>
                <div class="subtitle">
                    {{ company.nameAdd }}
                </div>


                <div >
                    <div class="adress v-flex">
                        <div>
                            {{ company.zip }} {{ company.city }}
                        </div>
                    </div>
                    <div class="adress v-flex">
                        <div>
                            {{ company.street }}
                        </div>
                    </div>
                </div>
                <div
                    v-if="allowEdit"
                    style="position: absolute; bottom: 2px; right: 2px"
                >
                    <c-toolbar-button
                        icon     = "mdi-pencil"
                        tooltip  = "Bearbeiten"
                        color    = "primary"
                        size     = "20"
                        @click   = "onEdit"
                    />
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>

import CompanyRoles from "@/modules/msd/company/common/components/controlls/CompanyRoles";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import DServicePartner from "@/modules/msd/company/servicepartner/components/controlls/DServicePartner.vue";
export default {
    name: "CompanyCard",
    components: {
        DServicePartner,
        CToolbarButton,
        CompanyRoles
    },

    props: {
        company: {
            required: false,
            type    : Object,
            default: function () {
                return null;
            }
        },

        background: {
            required: false,
            type    : String,
            default: function () {
                return null;
            }
        },

        allowEdit: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },
     },

    data: () => ({
        edit: false,
    }),

    computed: {
    },

    methods: {
        onCompany () {
            this.$emit("click", this.company);
        },

        onEdit () {
            this.edit = true;
        },

        onStored () {
            this.$emit("refresh", this.company);
        }
    }
}
</script>

<style scoped>

.company {
    height: 90px;
}

.company .header {
}

.company .subtitle {
    font-size: 12px;
    margin-top: -4px;
}

.company .name {
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.company .type {
    padding-top: 2px;
}

.company .type,
.company .company,
.company .company-add,
.company .adress,
.company .email {
    font-size: 13px;
    height: 18px;
}

.company .company,
.company .company-add {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


</style>